import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      redirect: "/Home"
    },
    {
      path: "/Home",
      meta: { roles: ["admin", "user"] },
      component: Home
    },
    {
      path: "/Donor/:name",
      meta: { roles: ["admin", "user"] },
      component: () => import(/* webpackChunkName: "Index" */ "./views/Donor.vue")
    },
    {
      path: "/Donor/:name/Floor/:floor/Area/:area",
      meta: { roles: ["admin", "user"] },
      component: () => import(/* webpackChunkName: "Index" */ "./views/DocDonor.vue")
    },
    {
      path: "/Floor/:floor/Area/:area",
      meta: { roles: ["admin", "user"] },
      component: () => import(/* webpackChunkName: "Index" */ "./views/DocArea.vue")
    },
    {
      path: "/QRcode/:qrcode",
      meta: { roles: ["admin", "user"] },
      component: () => import(/* webpackChunkName: "Index" */ "./views/DocQRcode.vue")
    },
    {
      path: "/DocAll",
      meta: { roles: ["admin", "user"] },
      component: () => import(/* webpackChunkName: "Index" */ "./views/DocAll.vue")
    },
    // {
    //   path: "/Floor/:floor/Area/:area/Document/:doc_id",
    //   meta: { roles: ["admin", "user"] },
    //   component: () => import(/* webpackChunkName: "Index" */ "./views/DocumentDetail.vue")
    // },
    {
      path: "/Document/:doc_id",
      meta: { roles: ["admin", "user"] },
      component: () => import(/* webpackChunkName: "Index" */ "./views/DocumentDetail.vue")
    },
    {
      path: "/Scan",
      meta: { roles: ["admin", "user"] },
      component: () => import(/* webpackChunkName: "Index" */ "./views/Scan.vue")
    },
    {
      path: "/Sort",
      meta: { roles: ["admin", "user"] },
      component: () => import(/* webpackChunkName: "Index" */ "./views/Sort.vue")
    },
    {
      path: "/Admin",
      meta: { roles: ["admin"] },
      component: () => import(/* webpackChunkName: "Admin" */ "./views/Admin.vue")
    },
    {
      path: "/Admin/AreaSet",
      meta: { roles: ["admin"] },
      component: () => import(/* webpackChunkName: "Admin" */ "./views/AdminAreaSet.vue")
    },
    {
      path: "/AdminQRcode",
      meta: { roles: ["admin"] },
      component: () => import(/* webpackChunkName: "Admin" */ "./views/AdminQRcode.vue")
    },
    {
      path: "/Admin/QRcode/Setting",
      meta: { roles: ["admin"] },
      component: () => import(/* webpackChunkName: "Admin" */ "./views/AdminQRcodeSetting.vue")
    },
    {
      path: "/AdminDocumentList",
      meta: { roles: ["admin"] },
      component: () => import(/* webpackChunkName: "Admin" */ "./views/AdminDocumentList.vue")
    },
    {
      path: "/AdminDocumentSet/:recno",
      meta: { roles: ["admin"] },
      component: () => import(/* webpackChunkName: "Admin" */ "./views/AdminDocumentSet.vue")
    },
    // {
    //   path: "/TestApp",
    //   meta: { roles: ["admin", "user"] },
    //   component: () => import(/* webpackChunkName: "Index" */ "./views/TestApp.vue")
    // },
    // {
    //   path: "/TestUpload",
    //   meta: { roles: ["admin", "user"] },
    //   component: () => import(/* webpackChunkName: "Index" */ "./views/TestUpload.vue")
    // },
    { path: "/*", meta: { roles: ["admin", "user"] }, redirect: "/" }
  ]
});
